<template>
  <ul class="operate">
    <li @click="itemClickHanlder">
      <!--        <img class="icon" src="../../../assets/images/icon/未选择.png" alt="">-->
      <!--                    <img class="icon" src="../../../assets/images/icon/已选择.png" alt="">-->

      <div class="lawyer">
        <img class="avatar" :src="data.avatar" alt="" />
        <div class="lawyer-info">
          <p class="lawyer-info-name">
            {{ data.name }}
            <em>{{ data.postName && data.postName.substr(0, 8) }}</em>
          </p>
          <p class="lawyer-info-address">{{ data.deptName }}</p>
          <div class="label">
            <p class="label-type" v-for="tag in data.tag">{{ tag }}</p>
          </div>

          <button class="advisory" v-if="data.consultFlag === 1" @click="makePhoneCall(data.phone)">咨询</button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  import app from '../../../jssdk'

  export default {
    name: 'libraryItem',
    props: {
      data: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {}
    },
    methods: {
      itemClickHanlder() {
        if (this.data.delFlag) {
          this.$toast('该信息已被管理员删除')
          return
        }
        this.$router.push({
          path: '/library/library-details',
          query: {
            id: this.data.id
          }
        })
      },
      makePhoneCall(phone) {
        app.makePhoneCall({
          phoneNumber: phone
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .operate {
    /*display: flex;*/
    /*align-items: center;*/

    li {
      display: flex;
      justify-content: space-between;
    }

    .icon {
      width: 14px;
      height: 14px;
      margin-right: 12px;
    }

    .lawyer {
      width: 351px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      margin-top: 12px;
      padding: 16px 12px;

      .avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }

      &-info {
        width: 100%;
        margin-left: 16px;
        position: relative;

        &-name {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 26px;

          em {
            height: 18px;
            border-radius: 2px;
            border: 1px solid #ff9800;
            box-sizing: border-box;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff9800;
            line-height: 18px;
            margin-left: 6px;
            padding-left: 4px;
            padding-right: 4px;
          }
        }

        &-address {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
        }

        &-address {
          max-width: 180px;
          margin-top: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .label {
          display: flex;
          flex-wrap: wrap;

          &-type {
            height: 20px;
            padding-left: 4px;
            padding-right: 4px;
            background: #f5f5f5;
            border-radius: 2px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            margin-top: 6px;
            margin-right: 8px;
          }
        }

        .advisory {
          position: absolute;
          top: 0;
          right: 0;
          width: 60px;
          height: 25px;
          background: #165ebf;
          border-radius: 4px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
        }
      }
    }
  }
</style>
